import { memo } from 'react';
import { styled } from '@mui/material/styles';
import DoughnutItem from './DoughnutItem';
import { useTranslation } from '@hooks';
import MetricItem from './MetricItem';

export const MetricGrid = styled('div')({
    display: 'grid',
    gridGap: 16,
    gridTemplateAreas: '"metric1 metric3 doughnut" "metric2 metric4 doughnut"',
    gridAutoColumns: 'minmax(270px, 300px) minmax(270px, 300px) auto',
    marginBottom: 16,
    '@media (max-width: 1420px)': {
        gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
        gridTemplateAreas: '"metric1 metric2" "metric3 metric4" "doughnut doughnut"',
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: '100%',
        gridTemplateAreas: '"metric1" "metric2" "metric3" "metric4" "doughnut"',
    },
});

const DoughnutRates = memo(({ data, isLoading, type }) => {
    const { t } = useTranslation();

    return (
        <MetricGrid>
            <MetricItem
                title={t('AnalyticsReviews.averageRating')}
                data={{ metric: data.averageRating, delta: data.averageRatingDelta }}
                styles={{ gridArea: 'metric1' }}
            />
            <MetricItem
                title={t('AnalyticsReviews.totalResponses')}
                data={{ metric: data.totalResponses, delta: data.totalResponsesDelta }}
                styles={{ gridArea: 'metric2' }}
                withPercentageDelta
            />
            <MetricItem
                title={t('AnalyticsReviews.negativeResponses')}
                data={{ metric: data.negativeResponses, delta: data.negativeResponsesDelta }}
                styles={{ gridArea: 'metric3' }}
                withPercentageDelta
            />
            <MetricItem
                title={t('AnalyticsReviews.nps')}
                data={{ metric: data.netPromoterScore, delta: data.netPromoterScoreDelta }}
                styles={{ gridArea: 'metric4' }}
            />
            <DoughnutItem data={data} isLoading={isLoading} type={type} />
        </MetricGrid>
    );
});

DoughnutRates.displayName = 'DoughnutRates';

export default DoughnutRates;
